<template>
  <v-navigation-drawer
    fixed
    clipped
    :disable-route-watcher="disableRouteWatcher"
    disable-resize-watcher
    v-model="sidebarState"
    app
  >
    <v-list dense>
      <v-list-tile
        v-for="link in _links"
        :key="link.to"
        :to="{name: link.to}"
        @click="sidebarState = !sidebarState"
      >
        <v-list-tile-action>
          <v-icon>{{link.icon}}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>
            {{link.title}}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'sidebar',
  data () {
    return {
      disableRouteWatcher: true
    }
  },

  computed: {
    sidebarState: {
      get () {
        return this._sidebarState
      },
      set (value) {
        this._toggleSidebar(value)
      }
    },
    ...mapGetters('tradle', {
      _links: 'links',
      _sidebarState: 'sidebarState'
    })
  },

  methods: {
    ...mapActions('tradle', {
      _toggleSidebar: 'toggleSidebar'
    })
  }
}
</script>

<style scoped>

</style>
